import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h } from 'preact';

import PartyPill from './PartyPill';
import OtherCandidate from './OtherCandidate';
import PureComponent from './PureComponent';

// internal
import { sort_candidates_by_party, presidentCandidateColors, senateCandidateColors } from '../election-utils';
import sumValues from '../utils/sum-values';
import { DEMOCRAT, NEUTRAL, OTHER } from '../colors';

interface Props {
  partyName: string;
  tableHeader: JSX.Element;
  isShowcaseRace?: boolean;
  isHomepage?: boolean;
  columnCount: number;
  visibleCandidatesCount: number;
  partyBallot: { [key: string]: any };
  renderCandidate: any;
  contestTitle: string;
  embedType: string;
}

class SeatPartyDivider extends Component {
  constructor() {
    super();

    this.state = {
      viewAllCandidates: false,
    };
    this.onViewableToggle = this.onViewableToggle.bind(this);
  }

  onViewableToggle() {
    this.setState(prevState => ({
      viewAllCandidates: !prevState.viewAllCandidates, // set viewAllCandidates to what is wasn't before
    }));
  }
  render() {
    const {
      partyName,
      partyBallot,
      tableHeader,
      isShowcaseRace,
      isHomepage,
      columnCount,
      visibleCandidatesCount,
      renderCandidate,
      contestTitle,
      embedType,
    } = this.props;

    const { viewAllCandidates } = this.state;

    const shouldDisplayResult = partyBallot.contest_result !== 'not called';

    const totalVotes = sumValues(partyBallot.candidacies, 'votes');

    let candidates = partyBallot.candidacies;

    let candidatesRender;

    let visibleCandidates = visibleCandidatesCount;

    let shouldDisplay5Candidates;

    let embedTypeUsable = 'none'
    
    if (typeof embedType !== 'undefined') {
      embedTypeUsable = embedType;
    }

    if (isShowcaseRace || embedTypeUsable.includes('broadcast')) {

      shouldDisplay5Candidates =
        partyBallot.office == 'President' && partyBallot.party == 'Democrat';

      candidatesRender = shouldDisplay5Candidates ? presidentCandidateColors : senateCandidateColors;

      visibleCandidates = shouldDisplay5Candidates ? 6 : 3;
    }

    if (partyBallot <= 0) {
      candidates = sort_candidates_by_party(candidates);
    }

    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democrat',
      'seat__race--Republican': partyName == 'Republican',
    });

    const contestCalledClass = cx('contest__called-row', {
      'dem-winner-banner': partyName == 'Democrat',
      'rep-winner-banner': partyName == 'Republican',
    });

    const contestResults =
      partyBallot.contest_result == 'runoff'
        ? `Will continue to ${partyBallot.contest_result}`
        : (partyBallot.contest_result == 'winner') ? `Projected ${partyBallot.contest_result}` : `${partyBallot.contest_result}`;

    const precinctsClass = cx('contest__precincts', {
      'tribcast' : embedType == 'tribcast'
    })

    const countdownClass = cx('countdown', {
      'tribcast' : embedType == 'tribcast'
    })

    return (
      <div class={rowClass}>
        <div class="race">
          <h4 class="race__title">
            {embedTypeUsable == 'partner' || embedTypeUsable.includes('broadcast') || isHomepage ? ( isHomepage ? <span>
                <h3 class="seat__title">{contestTitle} - {partyName}ic Primary </h3> 
              </span> : <span>
                <h3 class="seat__title">{contestTitle} - </h3> {partyName}
              </span>
            ) : (
              <span>{partyName}</span>
            )}

          </h4>
          

          <table class="race__candidates">
            {tableHeader}
            <tbody>
              {shouldDisplayResult && (
                <tr class={contestCalledClass}>
                  <td colSpan={columnCount}>{contestResults}</td>
                </tr>
              )}
              {(embedTypeUsable.includes('broadcast')) ||
                (isShowcaseRace &&
                  candidates.map((candidate: any, idx: any) =>
                    renderCandidate(
                      candidate,
                      idx,
                      candidatesRender,
                      viewAllCandidates,
                      { totalVotes }
                    )
                  ))}

              {!isShowcaseRace &&
                candidates.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx, viewAllCandidates, {
                    totalVotes,
                  })
                )}
              {(!(
                embedTypeUsable.includes('broadcast')
                ) && !isHomepage) && candidates.length > visibleCandidates && (
                  <OtherCandidate
                    isViewable={!viewAllCandidates}
                    candidateCount={candidates.length}
                    embedType={embedType}
                    onClick={() => {
                      this.onViewableToggle();
                    }}
                    showDelegates={shouldDisplay5Candidates}
                  />
                )}
            </tbody>
            
            {candidates.length > visibleCandidates && viewAllCandidates && (
              <tr class="candidate race__candidate-row">
                <td
                  class="candidate__cell candidate__party t-align-center"
                  onClick={() => {
                    this.onViewableToggle();
                  }}
                >
                  <svg class="icon icon-angle-up">
                    <use xlinkHref="#icon-angle-up" />
                  </svg>
                </td>
                <th class="candidate__cell candidate__name">
                  <button class={embedType}
                    onClick={() => {
                      this.onViewableToggle();
                    }}
                  >
                    Show fewer ({visibleCandidates})
                  </button>
                </th>
                <th class="candidate__cell candidate__votes"> </th>
                <th class="candidate__cell candidate__pct"></th>
              </tr>
            )}
          </table>
          
          {isHomepage && (
            <div class='homepage-link__full_results'><a href='https://apps.texastribune.org/features/2020/primary-election-results/'>View Full Results</a></div>
          )}
          {isHomepage && (
            <div class='dropped_out__div' style="margin-top: 0.625rem;">*Dropped out</div>
          )}
          {isHomepage && (
            <div class="contest__metrics" style="margin-top: 0.625rem;">
              <p class="contest__precincts">
                {`${intcomma(
                  partyBallot.pollinglocationsreporting
                )} of ${intcomma(
                  partyBallot.total_pollinglocations
                )} total polling locations reporting (${partyBallot.pollinglocations_reporting_percent.toFixed(
                  1
                )}%)`}
              </p>
              
            </div>
          )}

        {!isHomepage && (
          <div>
            {(partyBallot.office == 'President' && partyBallot.party == 'Democrat') && 
              (<div class='dropped_out__div'>*Dropped out</div>
            )}
            <div class="contest__metrics" style="padding-top: 3px;">
              <p class={precinctsClass}>
                {`${intcomma(
                  partyBallot.pollinglocationsreporting
                )} of ${intcomma(
                  partyBallot.total_pollinglocations
                )} total polling locations reporting (${partyBallot.pollinglocations_reporting_percent.toFixed(
                  1
                )}%)`}
              </p>
              
            </div>
          </div>
        )}

        {/* include on all of the results tables */}
        {(partyBallot.office == 'President' && partyBallot.party == 'Democrat') ? (
          <p class={precinctsClass} style="padding-top: 3px;">Source: Texas Secretary of State and Texas Democratic Party</p>
        ) : (
          <p class={precinctsClass} style="padding-top: 3px;">Source: Texas Secretary of State</p>
        )}

        {!isHomepage && (
          <div class={countdownClass}>
            Updating <span class="counter"></span>
          </div>
        )}
      </div>
      </div>
    );
  }
}

SeatPartyDivider.defaultProps = {
  visibleCandidatesCount: 3,
  isShowcaseRace: false,
  isHomepage: false,
};

export default SeatPartyDivider;
